<template>
  <div class="attachments-list">
    <div v-if="searchHasResults" class="attachments-list__cards">
      <AttachmentCard
        v-for="attachment in files"
        :key="attachment._id"
        :attachment="attachment"
        :isEditMode="isEditMode"
        :isPending="false"
        :organizationId="organizationId"
        :revId="revId"
      />
      <AttachmentCard
        v-for="attachment in pendingFiles"
        :attachment="attachment"
        :key="attachment.id"
        :isEditMode="isEditMode"
        :isPending="true"
      />
    </div>
    <div v-else class="attachments-list__empty-state-wrapper">
      <img
        class="attachments__empty-state-image"
        alt="empty_state"
        :src="emptySearchImage"
      />
      <p class="attachments__empty-state-title">
        {{
          $t('attachments.sorry_we_couldnt_find_any_result_matching', {
            context: search,
          })
        }}
      </p>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import mixin from '@/mixins/mixin.vue'
import AttachmentCard from '@/components/Core/Attachments/AttachmentCard.vue'

import emptySearchImage from '@/assets/images/empty-states/search-empty-state-attachments.svg'

export default {
  name: 'AttachmentsList',

  mixins: [mixin],

  components: {
    AttachmentCard,
  },

  props: {
    attachments: {
      type: Array,
      default() {
        return []
      },
      required: false,
    },

    pendingAttachments: {
      type: Array,
      default() {
        return []
      },
      required: false,
    },
    isEditMode: {
      type: Boolean,
      required: true,
    },
    revId: {
      type: String,
      required: true,
    },
    organizationId: {
      type: String,
      required: true,
    },
    search: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      emptySearchImage,
    }
  },

  computed: {
    files() {
      const items = this.attachments.map(element => {
        const mediaObject = element?.media

        return {
          _id: element?._id,
          mimeType: mediaObject?.mimeType,
          fileName: mediaObject?.originalFileName,
          size: this.formatBytes(mediaObject?.bytes),
          mediaObject,
        }
      })

      return items.filter(item => {
        return item?.fileName
          ?.toLowerCase?.()
          ?.includes?.(this.search?.toLowerCase?.())
      })
    },

    pendingFiles() {
      return this.pendingAttachments.map(element => {
        return {
          fileName: element?.name,
          mimeType: element?.type,
          size: this.formatBytes(element?.size ?? 0),
        }
      })
    },

    searchHasResults() {
      return !_.isEmpty(this.files) || !_.isEmpty(this.pendingAttachments)
    },
  },

  methods: {
    formatBytes(bytes, decimals = 2) {
      //  https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
  },
}
</script>

<style lang="scss" scoped>
.attachments-list {
  margin-bottom: 16px;
  &__empty-state {
    &-wrapper {
      text-align: center;
      padding: 20%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &-image {
      margin-bottom: 24px;
    }

    &-title {
      font-size: 16px;
      color: $color-blue-grey-darken3;
    }
  }
}
</style>
